import { render, staticRenderFns } from "./LinkShare.vue?vue&type=template&id=7398300c&scoped=true&"
import script from "./LinkShare.vue?vue&type=script&lang=ts&"
export * from "./LinkShare.vue?vue&type=script&lang=ts&"
import style0 from "./LinkShare.vue?vue&type=style&index=0&id=7398300c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7398300c",
  null
  
)

export default component.exports